import React from 'react';
import { useTranslation } from 'react-i18next';

const stripErrors = (error) => {
    const {t} = useTranslation();
    if(error ==='Your card number is invalid.'){
        return <>{t('invalid_card')}</>      
    }
    else if(error ==='Your card number is incomplete.'){
        return <>{t('incomplete_card')}</> 
    }
    else if(error==="Your card's expiration year is in the past."){
        return <>{t('card_year_expir_msg')}</> 
    }
    else if(error ==="Your card's expiration date is incomplete."){
        return <>{t('card_expiration_date_msg')}</> 
    }
    else {
       return error;
    }
  }
  export default stripErrors
  